import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=3a565810&"
import script from "./Attachment.vue?vue&type=script&lang=js&"
export * from "./Attachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a565810')) {
      api.createRecord('3a565810', component.options)
    } else {
      api.reload('3a565810', component.options)
    }
    module.hot.accept("./Attachment.vue?vue&type=template&id=3a565810&", function () {
      api.rerender('3a565810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Compose/Attachment.vue"
export default component.exports